import React, { lazy, Suspense } from 'react'
import Loader from '../MobileExchenger/elements/loader'

import Helmet from 'react-helmet'
import SFRegular from '../../fonts/sf_ui_display_regular.ttf'
import SFBold from '../../fonts/SFUIDisplay-Bold.ttf'
import SFHeavy from '../../fonts/SFUIDisplay-Heavy.ttf'
import SFMedium from '../../fonts/SFUIDisplay-Medium.ttf'
import SFSemibold from '../../fonts/SFUIDisplay-Semibold.ttf'
import MBold from '../../fonts/Montserrat-Bold.ttf'
import MExtraBold from '../../fonts/Montserrat-ExtraBold.ttf'
import MMedium from '../../fonts/Montserrat-Medium.ttf'
import MSemibold from '../../fonts/Montserrat-SemiBold.ttf'
import loaderBlack from '../../images/icon/loaderBlack.svg'
import loaderWhite from '../../images/icon/loaderWhite.svg'

import { withTranslation } from 'react-i18next'
import { Route } from 'react-router-dom'

const RenderMobileCheck = lazy(() => import('./mobileCheck'))

const renderMobileCheck = () => {
    return (
        <Suspense fallback={<div><Loader /></div>}>
            <RenderMobileCheck />
        </Suspense>
    )
}

const MobileCheckScreen = () => {

    return (
        <>
            <Helmet>
                <link rel={"preload"} href={loaderBlack} as={"image"} type={"image/svg+xml"} />
                <link rel={"preload"} href={loaderWhite} as={"image"} type={"image/svg+xml"} />
                <link rel={"preload"} href={SFRegular} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFBold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFHeavy} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFSemibold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFMedium} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MBold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MExtraBold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MSemibold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MMedium} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <meta name={"viewport"} content={"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"} />
            </Helmet>
            <div style={{ backgroundColor: '#F5F5F5' }}>
                <Route exact path={'/mobile-check'} component={renderMobileCheck} />
            </div>Î
        </>
    )
}
export default withTranslation()(MobileCheckScreen)